import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgbAlert, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, observable, Subject } from 'rxjs';

@Component({
  selector: 'app-list-payroll',
  templateUrl: './list-payroll.component.html',
  styleUrls: ['./list-payroll.component.scss'],
})
export class ListPayrollComponent implements OnInit {
  @ViewChild('selfClosingAlert', { static: false }) selfClosingAlert!: NgbAlert;
  @ViewChild('createReportModal', { static: false }) createReportModal!: TemplateRef<any>;
  @ViewChild('addPrizes', { static: false }) addPrizes!: TemplateRef<any>;
  @ViewChild('addDeductions', { static: false }) addDeductions!: TemplateRef<any>;
  @ViewChild('addExtrasNurse', { static: false }) addExtrasNurse!: TemplateRef<any>;

  prizesForm: any = FormGroup;
  generatePayroll: any = FormGroup;
  generateDeductions: any = FormGroup;
  generateExtras: any = FormGroup;
  modalClose: any;
  breadcrumbs: any = [];
  payrolls: any = [];
  cycles: any = [];
  submitted: boolean = false;
  flagErrors: boolean = false;
  isSaved: boolean = false;
  message: string = '';
  userName: string = '';
  payrollId: string = '';
  userId: string = '';
  private _error = new Subject<string>();

  constructor(
    private api: ApiService,
    private modal: NgbModal,
    private fb: FormBuilder,
    private gp: FormBuilder,
    private gd: FormBuilder,
    private en: FormBuilder,
  ) {}

  ngOnInit(): void {
    this._error.subscribe(
      (messageData: string) => (this.message = messageData)
    );
    this._error.pipe(debounceTime(5000)).subscribe(() => {
      if (this.selfClosingAlert) {
        this.selfClosingAlert.close();
        this.flagErrors = false;
        this.isSaved = false;
        this.message = '';
      }
    });

    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de Nominas',
        link: false,
      },
    ];

    this.validation();
    this.validationGenerate();
    this.deductionsData();
    this.deductionsNurseData();
    this.loadPayrolls();
    this.getCycles();
  }

  validation(): void {
    this.prizesForm = this.fb.group({
      payrollId: ['', [Validators.required]],
      amount: ['0', [Validators.required]],
      amount2: ['0', [Validators.required]]
    });
  }

  validationGenerate(): void {
    this.generatePayroll = this.gp.group({
      cycleId: ['', [Validators.required]],
    });
  }

  deductionsData(): void {
    this.generateDeductions = this.gd.group({
      deduction: ['', []],
      reason: ['', []],
      payrollId: ['', [Validators.required]],
      userId: ['', [Validators.required]],
      roleKey: ['', [Validators.required]]
    });
  }

  deductionsNurseData(): void {
    this.generateExtras = this.en.group({
      deduction: ['', []],
      reason: ['', []],
      deduction_2: ['', []],
      reason_2: ['', []],
      dateSession: ['', []],
      amountOff: ['', []],
      payrollId: ['', [Validators.required]],
      userId: ['', [Validators.required]],
      roleKey: ['', [Validators.required]]
    });
  }

  loadPayrolls() {
    this.api.get('payroll').subscribe({
      next: (payroll) => {
        this.payrolls = payroll.data;
      },
      error: (err) => {},
    });
  }

  getCycles(): void {
    this.api.get('cycles').subscribe({
      next: (cycles) => {
        this.cycles = cycles.cycles;
      },
      error: (err) => {},
    });
  }

  openCreateReport(): void {
    this.modalClose = this.modal.open(this.createReportModal, {
      size: 'md',
    });
  }

  openGifts(userName: string, payrollId: Number): void {
    this.resetPrizes();
    this.userName = userName;
    this.prizesForm.patchValue({
      payrollId: payrollId,
    });

    this.modalClose = this.modal.open(this.addPrizes, {
      size: 'md',
    });
  }

  openDeductions(payrollId: string, userId: string, userName: string, roleKey: string): void {
    this.userName = userName;

    if (roleKey === 'enf') {
      this.generateExtras.patchValue({
        payrollId: payrollId,
        userId: userId,
        roleKey: roleKey
      });

      this.modalClose = this.modal.open(this.addExtrasNurse, {
        size: 'lg'
      });
    } else {
      this.generateDeductions.patchValue({
        payrollId: payrollId,
        userId: userId,
        roleKey: roleKey
      });

      this.modalClose = this.modal.open(this.addDeductions, {
        size: 'md',
      });
    }
  }

  get f() {
    return this.prizesForm.controls;
  }

  get fg() {
    return this.generatePayroll.controls;
  }

  get gdv() {
    return this.generateDeductions.controls;
  }

  get den() {
    return this.generateExtras.controls;
  }

  generatePayrollForm(): void {
    this.submitted = true;

    if (this.generatePayroll.invalid) {
      this.submitted = false;
      this.flagErrors = true;
      this.message = '';

      return;
    }

    const obj = {
      cycle: this.generatePayroll.value.cycleId,
    };
    this.api.create('payroll', obj).subscribe({
      next: (data) => {
        this.submitted = false;
        this.isSaved = true;
        this.message = data.message;
        this._error.next(this.message);
        this.loadPayrolls();
        this.resetPrizes();
      },
      error: (err) => {},
    });
  }

  addPrizesForm() {
    this.submitted = true;
    this.flagErrors = false;

    if (this.prizesForm.invalid) {
      this.flagErrors = true;
      this.submitted = false;
      this.message = 'Por favor, ingrese la cantidad del premio.';
      this._error.next(this.message);

      return;
    }

    if (isNaN(this.prizesForm.value.amount)) {
      this.flagErrors = true;
      this.submitted = false;
      this.message = 'Por favor, ingrese una cantidad numerica.';
      return;
    }

    const obj = {
      payrollId: this.prizesForm.value.payrollId,
      amount: this.prizesForm.value.amount,
      amount2: this.prizesForm.value.amount2
    };

    this.api.create('payroll/prizes', obj).subscribe({
      next: (data) => {
        this.submitted = false;
        this.isSaved = true;
        this.message = data.message;
        this.prizesForm.patchValue({
          amount: '',
        });
        this._error.next(this.message);
        this.resetPrizes();
      },
      error: (err) => {},
    });
  }

  downloadPDF(payrollId: number): void {
    this.api.getById('payroll/pdf', payrollId).subscribe({
      next: (payroll) => {
        window.open(payroll.path, '_blank');
      },
      error: (err) => {},
    });
  }

  downloadExcelNurse(): void {
    const obj = {
      payrollId: this.generateExtras.value.payrollId ?? 0,
      userId: this.generateExtras.value.userId,
      deductions: this.generateExtras.value.deduction ?? '',
      reason: this.generateExtras.value.reason ?? '',
      deductions_2: this.generateExtras.value.deduction_2 ?? '',
      reason_2: this.generateExtras.value.reason_2 ?? '',
      dateSession: this.generateExtras.value.dateSession ?? '',
      amountOff: this.generateExtras.value.amountOff ?? ''
    };

    this.api.createFile('payroll/excel', obj).subscribe({
      next: response => {
        const blob = response.body!;
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'download';

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          
          if (match && match[1]) {
            filename = match[1];
          }
        }

        console.log(filename);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();

        window.URL.revokeObjectURL(link.href);
        this.modalClose.close();
      },
      error: err => {}
    })
  }

  downloadExcel(): void {
    const payrollId = this.generateDeductions.value.payrollId ?? 0;
    const userId = this.generateDeductions.value.userId;
    const deductions = this.generateDeductions.value.deduction;
    const reason = this.generateDeductions.value.reason.replace(' ', '_');

    this.api
      .getFile(`payroll/excel/${payrollId}/${userId}/${deductions}/${reason}`)
      .subscribe({
        next: (response) => {
          const blob = response.body!;
          const contentDisposition = response.headers.get('Content-Disposition');
          let filename = 'download';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+)"?/);
            
            if (match && match[1]) {
              filename = match[1];
            }
          }

          console.log(filename);
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(link.href);

          this.modalClose.close();
        },
        error: (err) => {},
      });
  }

  downloadExcelFile(
    payrollId: string,
    userId: string,
    deductions: string,
    roleKey: string
  ): void {
    if (roleKey != 'enf') {
      console.log('holas');
      this.api
        .getFile(`payroll/excel/${payrollId}/${userId}/${deductions}/na`)
        .subscribe({
          next: (response) => {
            const blob = response.body!;
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = 'download';

            if (contentDisposition) {
              const match = contentDisposition.match(/filename="?(.+)"?/);
              
              if (match && match[1]) {
                filename = match[1];
              }
            }

            console.log(filename);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();

            window.URL.revokeObjectURL(link.href);
          },
          error: (err) => {},
      });
    } else {
      this.api
          .getFile(`payroll/excelnurse/${payrollId}/${userId}`, {
            responseType: 'blob',
            observe: 'response'
          })
          .subscribe({
            next: (response) => {
              const blob = response.body!;
              const contentDisposition = response.headers.get('Content-Disposition');
              let filename = 'download';

              if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+)"?/);
                
                if (match && match[1]) {
                  filename = match[1];
                }
              }

              console.log(filename);
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = filename;
              link.click();

              window.URL.revokeObjectURL(link.href);
            },
            error: (err) => {}
          })
    }
  }

  close(): void {
    this.modalClose.close();
  }

  resetPrizes(): void {
    this.prizesForm.reset();
    this.generatePayroll.get('cycleId').setValue('');

    setTimeout(() => {
      this.submitted = false;
      this.flagErrors = false;
      this.isSaved = false;
      this.message = '';
      this.modalClose.close();
    }, 8000);
  }
}
